<template>
  <div class="product-page">
    <div class="product-page-banner">
      <div class="product-page-image">
        <img
          src="@/assets/exit.png?x-oss-process=image/format,webp"
          @click="closePage"
          class="exit-btn"
        />
      </div>
    </div>
    <div class="container">
      <!-- 顶部导航 -->
      <div class="top-nav">
        <div
          class="nav-item"
          :class="{ active: activeTab === 'product' }"
          @click="setActiveTab('product')"
        >
          <span class="nav-item-text">产品</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: activeTab === 'solution' }"
          @click="setActiveTab('solution')"
        >
          <span class="nav-item-text">解决方案</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: activeTab === 'about' }"
          @click="goToAboutPage"
        >
          <span class="nav-item-text">关于蓝悦</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: activeTab === 'resource' }"
          @click="setActiveTab('resource')"
        >
          <span class="nav-item-text">资源中心</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: activeTab === 'home' }"
          @click="goToIndexPage"
        >
          <span class="nav-item-text">首页</span>
        </div>
                <div
          class="nav-item"
          :class="{ active: activeTab === 'franchise' }"
          @click="goToFranchisePage"
        >
          <span class="nav-item-text">加盟中心</span>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content">
        <!-- 飞行平台 -->
        <div class="section" v-show="activeTab === 'product'">
          <div class="section-header" @click="toggleFlightSection">
            <h3>飞行平台</h3>
            <div class="arrow-up" :class="{ 'arrow-rotated': !flightSectionOpen }"></div>
          </div>
          <div class="products-list" v-show="flightSectionOpen">
            <div
              class="product-item"
              v-for="(product, index) in flightProducts"
              :key="index"
              @click="goToX15(product)"
            >
              <div class="product-img">
                <img :src="product.img" alt="" />
              </div>
              <div class="product-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.desc }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 智能控制系统 -->
        <div class="section" v-show="activeTab === 'product'">
          <div class="section-header" @click="toggleControlSection">
            <h3>智能控制系统</h3>
            <div class="arrow-up" :class="{ 'arrow-rotated': !controlSectionOpen }"></div>
          </div>
          <div class="products-list" v-show="controlSectionOpen">
            <div
              class="product-item"
              v-for="(product, index) in controlProducts"
              :key="index"
              @click="goToSmartDevice(product)"
            >
              <div class="product-img">
                <img :src="product.img" alt="" />
              </div>
              <div class="product-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="activeTab === 'product'">
          <div class="section-header" @click="toggleSolutionSection">
            <h3>毫米波雷达</h3>
            <div
              class="arrow-up"
              :class="{ 'arrow-rotated': !solutionSectionOpen }"
            ></div>
          </div>
          <div class="products-list" v-show="solutionSectionOpen">
            <div
              class="product-item"
              v-for="(product, index) in radarProducts"
              :key="index"
              @click="goToRadarDevice(product)"
            >
              <div class="product-img">
                <img :src="product.img" alt="" />
              </div>
              <div class="product-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="activeTab === 'product'">
          <div class="section-header" @click="togglePlatformSoftware">
            <h3>控制平台及软件</h3>
            <div
              class="arrow-up"
              :class="{ 'arrow-rotated': !platformSoftwareOpen }"
            ></div>
          </div>
          <div class="products-list" v-show="platformSoftwareOpen">
            <div
              class="product-item"
              v-for="(product, index) in platformSoftware"
              :key="index"
              @click="goToPlatformSoftware(product)"
            >
              <div class="product-img">
                <img :src="product.img" alt="" />
              </div>
              <div class="product-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="activeTab === 'solution'">
          <div class="products-list">
            <div
              class="product-item1"
              v-for="(product, index) in solutionProducts"
              :key="index"
              @click="goToSolution(product)"
            >
              <div class="product-info">
                <span>{{ product.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="section" v-show="activeTab === 'resource'">
          <div class="products-list">
            <div
              class="product-item1"
              v-for="(product, index) in resourceProducts"
              :key="index"
              @click="goToResource(product)"
            >
              <div class="product-info">
                <span>{{ product.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductComponent",
  data() {
    return {
      activeTab: "product",
      flightSectionOpen: true,
      controlSectionOpen: true,
      solutionSectionOpen: true,
      platformSoftwareOpen: true,
      solutionProducts: [
        {
          desc: "SmartPolicing",
          name: "智慧警务解决方案",
        },
        {
          desc: "ForestryFirefighting",
          name: "林业消防解决方案",
        },
        {
          desc: "NuclearIndustryRobot",
          name: "核工业机器人解决方案",
        },
        {
          desc: "PowerInspection",
          name: "电力巡检解决方案",
        },
      ],
      resourceProducts: [
        {
          name: "下载中心",
          desc: "DownloadCenter",
        },
        {
          name: "视频中心",
          desc: "VideoCenter",
        },
        {
          name: "资讯中心",
          desc: "InformationCenter",
        },
      ],
      flightProducts: [
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/LANYVE-X15.png?x-oss-process=image/format,webp",
          name: "LANYVE-X15",
          desc: "警用四旋翼无人机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/LANYVE-FH100.png?x-oss-process=image/format,webp",
          name: "LANYVE-FH100",
          desc: "垂直起降复合翼无人机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/LANYVE-GZ25.png?x-oss-process=image/format,webp",
          name: "LANYVE-GZ25",
          desc: "胜羽-电动共轴直升机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/LANYVE-X1.png?x-oss-process=image/format,webp",
          name: "LANYVE-X1",
          desc: "小型四旋翼无人机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/LANYVE-GZ500.png?x-oss-process=image/format,webp",
          name: "LANYVE-GZ500",
          desc: "胜羽-共轴双旋无人机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/LANYVE-Z100.png?x-oss-process=image/format,webp",
          name: "LANYVE-Z100",
          desc: "巨神单旋翼直升机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/LANYVE-ZX650.png?x-oss-process=image/format,webp",
          name: "LANYVE-ZX650",
          desc: "自旋翼无人机",
        },
      ],
      radarProducts: [
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMW4D/LANYVE-MMW4D.png?x-oss-process=image/format,webp",
          name: "LANYVE-MMW4D",
          desc: "避障雷达",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMWR/LANYVE-MMWR.png?x-oss-process=image/format,webp",
          name: "LANYVE-MMWR",
          desc: "测距雷达",
        },
      ],
      controlProducts: [
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FKA2%28FS%29.png?x-oss-process=image/format,webp",
          name: "LANYVE-FKA2(FS)",
          desc: "飞控计算机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-IDK-X3.png?x-oss-process=image/format,webp",
          name: "LANYVE-IDK-X3",
          desc: "任务载荷计算机",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JINSA6%28FS%29.png?x-oss-process=image/format,webp",
          name: "LANYVE-JINSA6(FS)",
          desc: "组合导航",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-L900%28FS%29.png?x-oss-process=image/format,webp",
          name: "LANYVE-L900(FS)",
          desc: "机载载荷电台",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JZA5.png?x-oss-process=image/format,webp",
          name: "LANYVE-IZA5",
          desc: "地面基站",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-4G-WIFI.png?x-oss-process=image/format,webp",
          name: "LANYVE-4G-WIFI",
          desc: "4G-WIFI",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FSROS-IMU.png?x-oss-process=image/format,webp",
          name: "LANYVE-FSROS-IMU",
          desc: "惯性测量单元",
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-DSA1.png?x-oss-process=image/format,webp",
          name: "LANYVE-DSA1",
          desc: "定速模块",
        },
      ],
      platformSoftware: [
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/glypt.png?x-oss-process=image/format,webp",
          code: "glypt",
          name: '无人机管控云平台',
          desc: '支持蓝悦、大疆产品，支持机场管控',
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/pcdmz.png?x-oss-process=image/format,webp",
          name: 'PC地面站软件',
          code: "PC",
          desc: '仿真飞行，多机控制',
        },
        {
          img:
            "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/yddmz.png?x-oss-process=image/format,webp",
          name: '移动地面站软件',
          code: "APP",
          desc: "远程控制安卓app",
        },
      ],
    };
  },
  created() {
    // 组件创建时读取保存的选中状态
    const savedTab = sessionStorage.getItem("activeTab");
    if (savedTab) {
      this.activeTab = savedTab;
    }
  },
  methods: {
    goToX15(product) {
      sessionStorage.setItem("activeTab", "product");
      this.closePage();
      // 延迟跳转，确保关闭动画完成（可选）
      this.$nextTick(() => {
        this.$router.push(`/x15?code=${product.name}`);
      });
    },
    goToSmartDevice(product) {
      sessionStorage.setItem("activeTab", "product");
      this.closePage();
      this.$nextTick(() => {
        this.$router.push(`/smartDevice?code=${product.name}`);
      });
    },
    goToRadarDevice(product) {
      sessionStorage.setItem("activeTab", "product");
      this.closePage();
      this.$nextTick(() => {
        this.$router.push(`/Radar?code=${product.name}`);
      });
    },
    goToSolution(product) {
      sessionStorage.setItem("activeTab", "solution");
      this.closePage();
      this.$nextTick(() => {
        this.$router.push(`${product.desc}`);
      });
    },
    goToResource(product) {
      sessionStorage.setItem("activeTab", "resource");
      this.closePage();
      this.$nextTick(() => {
        this.$router.push(`${product.desc}`);
      });
    },
    goToPlatformSoftware(product){
      sessionStorage.setItem("activeTab", "product");
      this.closePage();
      this.$nextTick(() => {
        this.$router.push(`/UAVControlPlatform?code=${product.code}`);
      });
    },
    goToAboutPage() {
      sessionStorage.setItem("activeTab", "about");
      this.closePage();

      // 延迟跳转，确保关闭动画完成（可选）
      this.$nextTick(() => {
        this.$router.push("/about");
      });
    },
    goToIndexPage() {
      sessionStorage.setItem("activeTab", "home");
      this.closePage();

      // 延迟跳转，确保关闭动画完成（可选）
      this.$nextTick(() => {
        this.$router.push("/");
      });
    },
    goToFranchisePage(){
            sessionStorage.setItem("activeTab", "franchise");
      this.closePage();

      // 延迟跳转，确保关闭动画完成（可选）
      this.$nextTick(() => {
        this.$router.push("/FranchiseCenter");
      });
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      sessionStorage.setItem("activeTab", tab);
    },
    closePage() {
      this.$emit("close");
    },
    // 可以添加更多方法
    toggleFlightSection() {
      this.flightSectionOpen = !this.flightSectionOpen;
    },
    toggleControlSection() {
      this.controlSectionOpen = !this.controlSectionOpen;
    },
    toggleSolutionSection() {
      // 新增
      this.solutionSectionOpen = !this.solutionSectionOpen;
    },
    togglePlatformSoftware(){
      this.platformSoftwareOpen = !this.platformSoftwareOpen;
    }
  },
  beforeDestroy() {
    // 清理事件监听
    this.$off();
  },
};
</script>

<style scoped>
.product-page {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0px; /* 头部高度 */
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #f8f9fa;
  z-index: 999;
  overflow-y: auto;
}
.product-page-banner {
  position: relative;
  width: 100%;
  height: 256px;
  background-color: white; /* 添加背景色 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* 防止被压缩 */
  z-index: 1000;
}

.product-page-image {
  position: relative;
  margin-top: 100px;
  margin-right: 1500px;
  width: 122.9px;
  height: 122.9px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.top-nav {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 573px;
  height: 1120px;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-item {
  flex: 1;
  display: flex;
  position: relative;
  justify-content: left;
  align-items: center;
  padding-left: 163.8px;
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 72px;
  color: #000000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-item.active {
  background: var(--15, #1c9af326);
  font-weight: bold;
  border-left: 20px solid #1c9af3;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 20px;
}

.section {
  margin-bottom: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 184px;
  padding-left: 81.9px;
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.3s ease;
}

.section-header h3 {
  font-size: 66.56px;
  color: #1c9af3;
  font-weight: 600;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #1c9af3;
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.products-list {
  display: flex;
  justify-content: center;
  justify-content: row;
  flex-wrap: wrap;
  gap: 16px;
}

.product-item {
  min-width: 150px;
  display: flex;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.product-item1 {
  min-width: 150px;
  display: flex;
  width: 100%;
  padding: 40.9px 81.9px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.product-item:hover {
  transform: translateY(-2px);
}

.product-img {
  position: relative;
  display: flex;
  justify-content: center;
  width: 245.7px;
  height: 245.7px;
  overflow: hidden;
}

.product-img img {
  object-fit: cover;
}

.product-info {
  position: relative;
  padding: 12px;
  display: flex;
  padding-left: 61px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}

.product-info h4 {
  font-size: 53.7px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.product-info span {
  font-size: 66.5px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.product-info p {
  font-size: 46px;
  color: #6c757d;
  margin: 0;
  line-height: 1.4;
}
</style>
